(function ($, _, Global) {
    _.templateSettings = {
        interpolate: /\{%=([\s\S]+?)%\}/g,
        escape: /\{%-([\s\S]+?)%\}/g,
        evaluate: /\{%([\s\S]+?)%\}/g
    };
    var Component = function (params) {
        var self = this;
        this.id = Math.floor(Math.random() * 26) + Date.now();
        this.parent = params.parent || null;
        this.element = null;
        this.template = params.template || null;
        this.children = params.children || [];
        this.events = $.Topic(this.id);
        this.store = new Global.Store({
            name: this.id + "-store",
            state: params.state || {},
            actions: params.actions
        });
        this.props = params.props || {};

        if (params.hasOwnProperty("created")) {
            this.created = params.created;
        }
        if (params.hasOwnProperty("updated")) {
            this.updated = params.updated;
        }
        if (params.hasOwnProperty("mounted")) {
            this.mounted = params.mounted;
        }

        if (this.store.actions !== {}) {
            for (var a in this.store.actions) {
                this.store.actions[a] = this.store.actions[a].bind(this);
            }
        }

        if ($(this.template).exists()) {
            this._template = _.template(this.template.innerHTML);
        } else {
            this._template = _.template("<div></div>");
        }

        this.events.subscribe(function (actionKey, payload) {
            self.store.dispatch(actionKey, payload);
        });

        this.store.events.subscribe(function (state) {
            if (self.updated && typeof self.updated === "function") {
                self.updated(state);
            }
            self.render(state);
        });
    };

    Component.prototype.render = function (state) {
        var _state = state || this.store.state.getAll();
        var html = this._template({
            data: {
                id: this.id,
                state: _state,
                props: this.props
            }
        });

        if (!this.element && typeof this.created === "function") {
            this.created(state);
        }

        var newElement = $(html)[0];

        if (this.children.length > 0) {
            var wrapper = $(newElement).find("[data-children]");
            var parent = wrapper.exists() ? wrapper[0] : newElement;

            for (var i = 0; i < this.children.length; i++) {
                var child = this.children[i];
                $(parent).append(child.render());

                if (typeof child.mounted === "function") {
                    child.mounted();
                }
            }
        }

        if (this.element) {
            $(newElement).insertAfter(this.element);
            $(this.element).remove();
        }
        this.element = newElement;

        if (!this.parent) {
            return this.element;
        } else {
            $(this.parent).append(newElement);

            if (typeof this.mounted === "function") {
                this.mounted();
            }
        }
    };

    Global.Component = Component;
})(jQuery, _, window);